import axios from 'axios';


export default class Service {

    #axios;
    #apiConfig;
    #serviceUrl = '';
    #mandatoryFields = {};

    constructor() {
        this.#axios = axios
    }


    // getters

    get axios() {
        return this.#axios
    }
    get apiConfig() {
        return this.#apiConfig
    }
    get serviceUrl() {
        return this.#serviceUrl
    }
    get mandatoryFields() {
        return this.#mandatoryFields
    }


    // setters

    set serviceUrl(newVal) {
        this.#serviceUrl = newVal
    }
    set mandatoryFields(newVal) {
        this.#mandatoryFields = newVal
    }


    // public methods

    checkMandatoryFields(requestData, mandatoryFieldsKey) {
        if (!this.mandatoryFields[mandatoryFieldsKey] || this.mandatoryFields[mandatoryFieldsKey].length === 0) return;
        for (const fieldName of this.mandatoryFields[mandatoryFieldsKey]) {
            if (!requestData[fieldName]) throw new Error(`Service is missing mandatory field: ${fieldName}`)
        }
    }
}